import StoreIcon from "../../../StoreIcon";

const AppStoreIcons = () => <StoreIcon />;

export default AppStoreIcons;
